const $ = jQuery.noConflict();
import 'slick-carousel';

const sliders = document.querySelectorAll('.component-slider');

const watchSliderChange = () => {
	$('.component-slider.component-slider-lower-arrows-and-progress-bar').on(
		'beforeChange',
		function (event, slick, currentSlide, nextSlide) {
			const $section = slick.$slider.closest('section');
			const slideCount = slick.$slider.find(
				'.slick-slide:not(.slick-cloned)'
			).length;
			const slideScroll = slick.options.infinite
				? 1
				: slick.options.slidesToShow;

			if ($section.find('.component-slider__progress-bar').length) {
				const barDifference =
					$section
						.find('.component-slider__progress-bar')
						.outerWidth() -
					$section
						.find('.component-slider__progress-slider')
						.outerWidth();
				const pixelInterval =
					barDifference / (slideCount - slideScroll);
				const maxLeft =
					barDifference < nextSlide * pixelInterval
						? barDifference
						: nextSlide * pixelInterval;
				$section
					.find('.component-slider__progress-slider')
					.css('marginLeft', maxLeft);
			}
		}
	);
};

const isProgressBarNeed = () => {
	let hasProgressBar = true;

	const $blockCards = $('.component-slider.component-slider-lower-arrows-and-progress-bar');
	if (!$blockCards.length) {
		return hasProgressBar;
	}
	const cardsPerRow = $blockCards.parent('[data-cardsperrow]').attr('data-cardsperrow');
	if (!cardsPerRow) {
		return hasProgressBar;
	}
	const slidesCount = $blockCards.find('.slick-slide:not(.slick-cloned)').length;

	if (parseInt(cardsPerRow) > slidesCount) {
		$blockCards.removeClass('component-slider-lower-arrows-and-progress-bar');
		hasProgressBar = false;
	}

	return hasProgressBar;
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (sliders.length) {
			sliders.forEach((slider) => {
				if (!slider.hasAttribute('data-slick')) {
					const parentWithSettings = slider.closest('[data-slick]');

					if (parentWithSettings) {
						slider.setAttribute(
							'data-slick',
							parentWithSettings.getAttribute('data-slick')
						);
					}
				}
			});

			$('.component-slider').slick();

			$(window).on('block-library-change', function () {
				$('.component-slider').slick('refresh');
			});

			let showProgressBar = isProgressBarNeed();

			if (showProgressBar) {
				watchSliderChange();
			}
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
